import React, { ReactNode } from 'react';
import classnames from 'classnames';
import styles from './FloMenuButton.module.css';
import { Dropdown } from 'react-bootstrap';
import { FloComponentProps } from 'components';

export enum FloMenuButtonItemType {
  DEFAULT,
  DIVIDER,
}

export interface FloMenuButtonItem {
  id:           string;
  title:        string | ReactNode;
  description?: string;
  onClick?:     (id: string) => void;
  disabled?:    boolean;
  type?:        FloMenuButtonItemType;
}

export interface FloMenuButtonProps extends FloComponentProps {
  text:         string;
  menuItems:    FloMenuButtonItem[];
}

export const FloMenuButton: React.FC<FloMenuButtonProps> = React.memo(({
  className,
  name = 'action-dropdown-basic',
  text,
  menuItems,
}) => {

  return (
    <Dropdown className = {classnames(styles.root, className)} drop="down">
      <Dropdown.Toggle className={styles.button} id={name}>
        {text}
      </Dropdown.Toggle>

      <Dropdown.Menu className={styles.menu}>
        {
          menuItems.map((item, index) => (
            item.type === FloMenuButtonItemType.DIVIDER ?
              <Dropdown.Divider key={`dropdown-item-${name}-divider-${index}`}/>
            :
              <Dropdown.Item
                key={`dropdown-item-${name}-${item.id}`}
                onClick={() => item.onClick ? item.onClick(item.id) : {}}
                className={styles.item}
                disabled={item.disabled}
              >
                <div className={classnames(styles.title, {[styles.itemDisabled]: item.disabled})}>{item.title}</div>
                { item.description && <div className={styles.description}>{item.description}</div> }
              </Dropdown.Item>
          ))
        }
      </Dropdown.Menu>
    </Dropdown>
  );
})

export default FloMenuButton;
